import type { MessageInput } from '@dev-streetbeat/chat/types';

// Agent-facing command for the "Crea una diagnosi" pill. The wording must
// stay aligned with the trigger-phrase list of the backend hint
// street-beat-fastapi/streetbeat_fastapi/skills/fineco/config/hints/
// fineco-portfolio-diagnose-flow.md — the hint is semantically selected, and
// this exact phrase is in its trigger list to guarantee the match.
export const FINECO_DIAGNOSI_AGENT_COMMAND =
  'Esegui la diagnosi del portafoglio importato adesso.';

// Flipped two-message split (same mechanism as the Vincoli Invia recap in
// useConstraintsMetadata, with the channels reversed): the advisor sees the
// pill text exactly as before (hidden_from_agent), while the agent receives
// an unambiguous command (hidden) instead of the bare three-word pill label
// that intermittently failed to select the diagnose-flow hint.
export function buildDiagnosiMessages(visibleText: string): MessageInput[] {
  return [
    { role: 'user', content: visibleText, hidden_from_agent: true },
    { role: 'user', content: FINECO_DIAGNOSI_AGENT_COMMAND, hidden: true },
  ];
}
